import React from 'react'

const EMPTY_STYLE_ID = 'emp-styles'

const EMPTY_CSS = `
.emp{
   --emp-fg: var(--brand, #1B3A6B);
   --emp-tint: var(--brand-dim, rgba(27,58,107,.09));
   --emp-ring: rgba(27,58,107,.10);
   --emp-title: #16202e;
   --emp-muted: #6b7684;
   --emp-ease: var(--ease, cubic-bezier(.2,.8,.2,1));

   display: flex;
   align-items: center;
   justify-content: center;
   width: 100%;
   padding: 56px 20px;
   font-family: 'Geist', 'Geist Sans', system-ui, -apple-system, 'Segoe UI', sans-serif;
   -webkit-font-smoothing: antialiased;
}

[data-bs-theme="dark"] .emp{
   --emp-fg: #9db4d8;
   --emp-tint: rgba(255,255,255,.06);
   --emp-ring: rgba(255,255,255,.10);
   --emp-title: #e8ecf2;
   --emp-muted: #98a2b3;
}

.emp-box{
   display: flex;
   flex-direction: column;
   align-items: center;
   text-align: center;
   max-width: 300px;
   animation: emp-in .42s var(--emp-ease) both;
}

.emp-icon{
   width: 60px;
   height: 60px;
   border-radius: 18px;
   display: grid;
   place-items: center;
   font-size: 26px;
   line-height: 1;
   color: var(--emp-fg);
   background: var(--emp-tint);
   box-shadow: inset 0 0 0 1px var(--emp-ring);
   animation: emp-pop .5s var(--emp-ease) both;
}

.emp-icon > *{ font-size: inherit; line-height: 1; }
.emp-icon svg{ width: 1em; height: 1em; display: block; }

.emp-title{
   margin: 18px 0 0;
   font-size: 15px;
   font-weight: 600;
   letter-spacing: -.012em;
   color: var(--emp-title);
}

.emp-msg{
   margin: 6px 0 0;
   font-size: 13.5px;
   font-weight: 450;
   line-height: 1.5;
   letter-spacing: -.004em;
   color: var(--emp-muted);
   text-wrap: balance;
}

.emp-action{ margin-top: 20px; }

/* Variante compacta: para paneles, offcanvas o celdas de tabla */
.emp-compact{ padding: 32px 16px; }
.emp-compact .emp-icon{ width: 46px; height: 46px; border-radius: 14px; font-size: 20px; }
.emp-compact .emp-title{ margin-top: 14px; font-size: 14px; }
.emp-compact .emp-msg{ font-size: 12.5px; }

@keyframes emp-in{
   from{ opacity: 0; transform: translateY(8px); }
   to{ opacity: 1; transform: none; }
}
@keyframes emp-pop{
   from{ opacity: 0; transform: scale(.94); }
   to{ opacity: 1; transform: none; }
}

@media (prefers-reduced-motion: reduce){
   .emp-box, .emp-icon{ animation: none; }
}
`

function Empty(props) {
   React.useEffect(() => {
      if (document.getElementById(EMPTY_STYLE_ID)) return
      const tag = document.createElement('style')
      tag.id = EMPTY_STYLE_ID
      tag.textContent = EMPTY_CSS
      document.head.appendChild(tag)
   }, [])

   return (
      <div className={`emp${props.compact ? ' emp-compact' : ''}`} role="status" aria-live="polite">
         <div className="emp-box">
            <div className="emp-icon" aria-hidden="true">
               {props.icon}
            </div>

            <h5 className="emp-title">{props.title}</h5>

            <p className="emp-msg">
               ¡{props.msg}!
            </p>

            {props.action ? <div className="emp-action">{props.action}</div> : null}
         </div>
      </div>
   )
}

export default Empty